import React, { Component } from 'react';
import styles from './palette.less.js';
import { limit } from '../../../../../utils/math-utils.js';

class ColorInput extends Component {
    constructor() {
        super(...arguments);
        this.handleChange = (e) => {
            const { value } = e.target;
            if (this.props.range) {
                const [min, max] = this.props.range;
                this.props.onChange(`${limit(parseInt(value || '0', 10), min, max)}`);
            }
            else {
                this.props.onChange(value);
            }
        };
    }
    render() {
        const { value, label, flex, style, } = this.props;
        return (React.createElement("div", { style: Object.assign({ flex: `${flex} 1 0%` }, style) },
            React.createElement("input", { className: styles.input, spellCheck: false, value: value, onChange: this.handleChange, onMouseDown: e => e.stopPropagation() }),
            React.createElement("span", { className: styles.text }, label)));
    }
}

export { ColorInput };
//# sourceMappingURL=input.js.map
